import { render, staticRenderFns } from "./CreateSheetForm.vue?vue&type=template&id=22d63e00"
import script from "./CreateSheetForm.vue?vue&type=script&lang=ts"
export * from "./CreateSheetForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports